import React,{useState,useEffect} from 'react';
import { FieldType } from 'common/consts/fieldType';
import { isNullOrWhiteSpace } from 'common/helpers/string';
import { parseRawNumber, formatNumber } from 'templates/IncomeAndExpendituresPageData/Utils/FormatNumbers'
import styles from './CalculationSection.module.scss';


interface Props {
    Model?: any; // Data from backend
    PageData?: any;
    showClaculation:boolean;    
    handleClick:any;
    disposableIncome:Function;
    disposableIncomeAmount:any;
    setCollapseCalculation:any;
    currencyClass:any;
}

const CalculationSection = ({
    Model,
    PageData,
    showClaculation,    
    handleClick,
    disposableIncome,
    disposableIncomeAmount,
    setCollapseCalculation,
    currencyClass
}: Props) => {

    const handleCollapse =() =>{
        handleClick(false) ; 
        setCollapseCalculation(false);          
    }

    const [monthlyIncome, setMonthlyIncome] = useState<any>();
    const [monthlyExpenses, setMonthlyExpenses] = useState<any>();
    const [monthlyPayments, setMonthlyPayments] = useState<any>();  
    const [incomeAmount, setIncomeAmount] = useState<any>();   
    

    const calculateIncomeTotal = () => {        

        let totalIncome = (parseRawNumber(monthlyIncome, 2) -
            (parseRawNumber(monthlyExpenses, 2) + parseRawNumber(monthlyPayments, 2)));
        
            totalIncome = totalIncome<0 ? 0: totalIncome;  
       
            setIncomeAmount(totalIncome);
            disposableIncome(totalIncome);
    };

    const enterIncomeTotal = () => { 
        setMonthlyIncome(0);
        setMonthlyExpenses(0); 
        setMonthlyPayments(0); 
        console.log('disposableIncomeAmount:-',disposableIncomeAmount);       
        setIncomeAmount(disposableIncomeAmount);
    };

    function onChangeMonthlyIncome(e: any) {        
        setMonthlyIncome(e.target.value);
    }

    function onChangeMonthlyExpenses(e: any) {
        setMonthlyExpenses(e.target.value);
    }

    function onChangeMonthlyPayments(e: any) {
        setMonthlyPayments(e.target.value); 
    }

    const preventMinus = (e:any) => {
        if (e.code === 'Minus') {
            e.preventDefault();
        }
    };

    useEffect(() => {
        calculateIncomeTotal();
    },[monthlyIncome, monthlyExpenses,monthlyPayments,disposableIncomeAmount ]);

    useEffect(() => {
        enterIncomeTotal();
    },[disposableIncomeAmount ]);

    return (       
            
        <div id="calculator-panel" className="Grid Grid--gutterH Grid--white GridWhite--smFull ">
                    <div className="Grid-cell">
                        <form className="Calculator Form Form-inputIndent">
                            <span className="Calculator-close js-calcularClose  u-colorTextLightGray" onClick={handleCollapse}><span className="u-hidden u-lg-inline">{PageData.CloseButtonLabel}</span> <img src={`${process.env.PUBLIC_URL}/images/icons/close.svg`}/></span>
                            <div className="Calculator-expenses">
                                <label className="Label Form-label">{PageData.EnterDisposableMonthlyIncomeLabel}</label>
                                <div className={'Input Input-icon Input-icon--before ' + currencyClass}>
                                    <input type="text"                                           
                                           placeholder="0,0"
                                           className="form-control h-input"                                           
                                           id="MonthlyIncome"
                                           tabIndex={2}
                                           autoComplete="off"
                                           inputMode="numeric"
                                           onChange={(val) => { onChangeMonthlyIncome(val); }}
                                           onKeyPress={preventMinus}/> 
                                           <span></span>                                   
                                </div>
                                <label className="Label Form-label">{PageData.EnterDisposableMonthlyExpensesLabel}</label>
                                <div className={'Input Input-icon Input-icon--before ' + currencyClass}>
                                    <input type="text"                                           
                                           placeholder="0,0"
                                           className="form-control h-input"                                          
                                           id="MonthlyExpenses" 
                                           tabIndex={3}
                                           autoComplete="off"
                                           inputMode="numeric"
                                           onChange={(val) => { onChangeMonthlyExpenses(val); }}
                                           onKeyPress={preventMinus}/>
                                           <span></span>                                     
                                </div>
                                <label className="Label Form-label">{PageData.EnterDisposableMonthlyPaymentsLabel}</label>
                                <div className={'Input Input-icon Input-icon--before ' + currencyClass}>
                                    <input type="text"                                    
                                           placeholder="0,0"
                                           className="form-control h-input"                                           
                                           id="MonthlyPayments"
                                           tabIndex={4}
                                           autoComplete="off"
                                           inputMode="numeric"
                                           onChange={(val) => { onChangeMonthlyPayments(val); }}
                                           onKeyPress={preventMinus}/>
                                           <span></span>                                     
                                </div>
                            </div>
                            <div className="Calculator-separator">
                            </div>
                            <div className="Calculator-availableIncome">
                                <div>
                                    <h3 className="availebleIncome-heading">{PageData.DisposableIncomeLabel}</h3>
                                    {(Model?.PageData?.DisposableIncomeTooltipText !== null && !Model?.PageData?.DisposableIncomeTooltipText.IsEmpty) &&
                                    (
                                    <div className="Tooltip Tooltip--info js-tooltipOpen">
                                    <span className="Tooltip Tooltip-content">
                                        <p className="Tooltip Tooltip-text">
                                            <span className="Tooltip-button js-tooltipOpen"></span>
                                            {PageData?.DisposableIncomeTooltipText}
                                        </p>
                                    </span>
                                </div>
                                )}                                   
                                </div>
                                <div className={'Input Input-icon Input-icon--before ' + currencyClass}>
                                    <input type="text" value={incomeAmount} placeholder="0.0" v-model="disposableIncome" id="availableincome"/>                                    
                                    <span></span>  
                                </div>
                            </div>
                        </form>
                    </div>
                </div>
               
       

    );

};

export default CalculationSection; 